module.exports = __webpack_public_path__ + "img/dragon-fruit-350x184.adbd5082.jpg";